import { Box, useTheme, IconButton, Typography, Divider } from '@mui/material'
// import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { Close as CloseIcon } from '@mui/icons-material'

import { CustomModalAnimated } from 'src/components/modal-animated'
import { useTranslation } from 'react-i18next'
import { QuillHtmlParser } from 'src/components/quill-html-parser'
import { IWhiteLabelOverrides } from 'src/types'

interface IProps {
  open: boolean
  handleClose: () => void
  overrides?: IWhiteLabelOverrides
}

export const AboutThisPageModal = ({ open, handleClose, overrides }: IProps) => {
  const [t] = useTranslation()
  const theme = useTheme()
  // const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  // const copyToClipboard = (value: string) => {
  //   navigator.clipboard.writeText(value)
  // }

  return (
    <CustomModalAnimated
      ariaLable="modal-about-this-page"
      open={open}
      handleClose={handleClose}
      sx={{
        width: '100dvw',
      }}
    >
      <Box
        id="about-this-page-modal-wrapper"
        sx={{
          boxSizing: 'border-box',
          position: 'relative',
          width: '100%',
          maxWidth: '800px',
          margin: '0 auto',
          padding: '5px 32px 20px',
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
        }}
      >
        <Typography variant="h4" sx={{ mt: '10px' }}>
          About this page
        </Typography>
        <Divider />
        <QuillHtmlParser
          html={
            overrides?.['journey-information-about-popup']?.value ??
            t('journey-information-about-popup')
          }
        />
      </Box>
      <IconButton
        id="about-this-page-modal-close"
        onClick={handleClose}
        sx={{
          position: 'fixed',
          top: 4,
          right: 8,
          zIndex: 103,
          color: theme.palette.common.black,
        }}
      >
        <CloseIcon />
      </IconButton>
    </CustomModalAnimated>
  )
}
